import { useQueryClient } from "@tanstack/react-query";
import { getAIRsDataQueryOptions, getInReviewDetailsQueryKey } from "shared-ui";
import { useCustomerAppConfig } from "undercarriage";

import { ConnectionAuthCallbackHandler, GetStarted } from "../../components";
import { FUNDING_APPLICATION_CONNECTORS_API, NAVIGATION_PATHS } from "../../components/constants";
import { platformConnectorsQueryParams, useHandleAirConnection } from "../../hooks/air-connection";

export const GetStartedPage = () => {
  const queryClient = useQueryClient();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const { handleSuccess: handleAirConnectionSuccess, handleError: handleAirConnectionError } = useHandleAirConnection({
    airBasePath: NAVIGATION_PATHS.GET_STARTED_ADDITIONAL_INFORMATION_REQUEST,
  });

  return (
    <ConnectionAuthCallbackHandler
      onSuccess={async (args) => {
        await queryClient.invalidateQueries({
          queryKey: [
            FUNDING_APPLICATION_CONNECTORS_API.replace(":customerSlug", customerDomain),
            platformConnectorsQueryParams,
          ],
        });
        await handleAirConnectionSuccess(args);
        await queryClient.invalidateQueries({
          queryKey: getInReviewDetailsQueryKey(customerDomain),
        });
        await queryClient.invalidateQueries({ queryKey: getAIRsDataQueryOptions(customerDomain).queryKey });
      }}
      onError={handleAirConnectionError}
    >
      <GetStarted />
    </ConnectionAuthCallbackHandler>
  );
};
